import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import type { Profile } from "@circle-react/types/CommunityBot/Profile";
import { useMemo } from "react";
import { useQuery } from "react-query";

interface BotProfileSearchResponse {
  records: Profile[];
}

export const useCommunityBotProfileSearch = ({
  name = "",
  disabled = false,
} = {}) => {
  const fetchBotProfiles = (): Promise<BotProfileSearchResponse> =>
    reactQueryGet(
      internalApi.communityInbox.botSearch({
        params: { name },
      }),
    );

  const isEnabled = !disabled;

  const { data, isInitialLoading } = useQuery<BotProfileSearchResponse>({
    queryKey: ["community-inbox", "chat-bot", "profiles", name],
    queryFn: fetchBotProfiles,
    enabled: isEnabled,
    staleTime: name === "" ? 5 * 60 * 1000 : 0,
    gcTime: 10 * 60 * 1000,
  });

  const botProfiles = useMemo<Profile[]>(
    () => data?.records ?? [],
    [data?.records],
  );

  return {
    botProfiles,
    isBotsLoading: isInitialLoading,
  };
};
